
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageBeforeIn: function () {
      this.$app.statusbar.setBackgroundColor('#ffffff');
      this.$app.statusbar.setTextColor('black');
    }
  },
  id: '0e4901701b',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n    <div class="page" data-name="offers">\r\n        <div class="navbar">\r\n            <div class="navbar-bg"></div>\r\n            <div class="navbar-inner sliding">\r\n                <div class="left">\r\n                    <a href="#" class="link back">\r\n                        <i class="icon icon-back"></i>\r\n                        <span class="if-not-md">Back</span>\r\n                    </a>\r\n                </div>\r\n                <div class="title">Offers</div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class="page-content offers-page">\r\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.offers && this.offers.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="offers-list">\r\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.offers, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                <div class="card offer-card">\r\n                    ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.image_url', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                    <div class="offer-image">\r\n                        ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.link', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\r\n                        <a href="';
                      r += c(ctx_5.link, ctx_5);
                      r += '"><img src="';
                      r += c(ctx_5.image_url, ctx_5);
                      r += '" alt="';
                      r += c(ctx_5.title, ctx_5);
                      r += '"></a>\r\n                        ';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += '\r\n                        <img src="';
                      r += c(ctx_5.image_url, ctx_5);
                      r += '" alt="';
                      r += c(ctx_5.title, ctx_5);
                      r += '">\r\n                        ';
                      return r;
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\r\n                    </div>\r\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                    <div class="card-content card-content-padding">\r\n                        <div class="offer-title">';
              r += c(ctx_3.title, ctx_3);
              r += '</div>\r\n                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.description', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                        <div class="offer-desc">';
                  r += c(ctx_4.description, ctx_4);
                  r += '</div>\r\n                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.valid_till', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                        <div class="offer-valid">Valid till ';
                  r += c(ctx_4.valid_till, ctx_4);
                  r += '</div>\r\n                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                    </div>\r\n                </div>\r\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="offers-empty">\r\n                <i class="icon f7-icons if-not-md">tag</i>\r\n                <i class="icon material-icons md-only">local_offer</i>\r\n                <p>No offers available right now.<br>Check back soon!</p>\r\n            </div>\r\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n        </div>\r\n    </div>\r\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    